import { useEffect, useState } from "react";
import { useUser } from "@clerk/clerk-react";
import { useLocation, useNavigate } from "react-router-dom";
import { PartyPopper } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import WhatsAppCTA from "@/components/WhatsAppCTA";

export default function OnboardingWhatsAppWelcome() {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user?.id || !location.state?.showWhatsAppWelcome) return;
    const key = `ffa-whatsapp-welcome-${user.id}`;
    if (localStorage.getItem(key) !== "seen") setOpen(true);
    // Remove the navigation flag so refreshing or returning to the dashboard cannot reopen the popup.
    navigate(location.pathname + location.search, { replace: true, state: null });
  }, [user?.id, location.state, location.pathname, location.search, navigate]);

  const dismiss = () => {
    if (user?.id) localStorage.setItem(`ffa-whatsapp-welcome-${user.id}`, "seen");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) dismiss(); }}>
      <DialogContent className="max-w-md rounded-md border-primary/30 bg-card text-center">
        <DialogHeader className="items-center pt-3 text-center">
          <span className="mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-primary/15 text-primary"><PartyPopper className="h-7 w-7" /></span>
          <DialogTitle className="text-2xl">You're in. Welcome to FFA!</DialogTitle>
          <DialogDescription className="pt-2 text-sm leading-relaxed">
            Your profile is ready. Join the official FFA × FPL managers WhatsApp community and connect with managers from around the world.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 pt-2">
          <WhatsAppCTA className="w-full justify-center" onJoined={dismiss} />
          <Button variant="ghost" onClick={dismiss} className="min-h-11 w-full">Maybe later</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}